




































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwBarProgress } from '@libs-uuif/shared/sw-progress';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { MswWidgetCard } from '@/shared/custom-component/msw-widget-card';
import  { MswApiService } from '@/shared/msw-api-service';
import { confirmService, ConfirmOptions } from '@libs-uuif/shared/confirm-service';
const cssPrefix = 'msw-supportcases-widget';

@Component({
  components: {
    MswWidgetCard,
    SwBarProgress,
    SwIcon,
  },
})
export default class MswSupportcasesWidget extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  casesInWait = '0';
  openCases = '0';
  waitForResp = false;
  routeToCases() {
    // Redirecting to managecases page
    this.$store.dispatch('navigateTo', 'ui/managecases');
  }

  created() {
    this.waitForResp = true;
    // const supportData = localStorage.getItem('supportCasesData') || null;
    // if (supportData === null) {
    MswApiService.widgetsInfo.getSupportCases()
      .then((resp:any) => {
        this.waitForResp = false;
        localStorage.setItem('supportCasesData', JSON.stringify(resp));
        if (resp['msgDesc'] === 'Success') {
          this.casesInWait  = resp['waitOnCustomerCount'] ? resp['waitOnCustomerCount'] : '0';
          this.openCases = resp['openCaseCount'] ? resp['openCaseCount'] : '0';
          if (resp['issueexist'] === 'YES') {
            const options: ConfirmOptions = {
              status: 'major',
              title: String(resp['issueheader']),
              message: String(resp['issuetext']),
              buttons: [{ key: 'ok', name: String(resp['issueoktext']), isDefault: true }],
            };

            if (resp['issuecanceltext']) {
              options.buttons?.splice(0, 0, { key: 'cancel', name: String(resp['issuecanceltext']) });
            }
            confirmService.confirm(options)
            .then((isConfirmed : any) => {
              if (isConfirmed === 'ok') {
                window.open(resp['issueactionurl'], '_blank');
              }
            });
          }
        }
        if (resp['msgDesc'] !== 'Success') {
          throw new Error(resp['msgDesc']);
        }
      })
      .catch((err:any) => {
        this.waitForResp = false;
        console.warn(`Error:${err}`);
      });
    // } else {
    //   const tempSupportData = typeof(supportData) === 'string' ? JSON.parse(supportData) : {};
    //   this.waitForResp = false;
    //   this.casesInWait  = tempSupportData['waitOnCustomerCount'] ? tempSupportData['waitOnCustomerCount'] : '-';
    //   this.openCases = tempSupportData['openCaseCount'] ? tempSupportData['openCaseCount'] : '-';
    // }
  }
}
